export default __webpack_public_path__ + "static/media/dpd-logo.4ea8da79.svg";